import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";
import LanguageSelector from "../../localization/LanguageSelector";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const FooterPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  // width: '100%'
}));

const FooterTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  textAlign: "center",
}));

const FooterLink = FooterTypography.withComponent("a");

function GlobalFooter() {
  const {t} = useTranslation()
  return (
    <AppBar position="static">
      <FooterPaper>
        <Container maxWidth={false}>
          <Stack alignItems="center">
            <Box>
              <img
                style={{ maxHeight: "100px" }}
                src="/caresense_big-removebg-preview.png"
                alt="caresense logo"
              />
            </Box>

            <Box sx={{ marginBottom: "20px" }}>
              <FooterTypography>
                  {t('medtrak_copyright')}
              </FooterTypography>
            </Box>
            <Box >
              <LanguageSelector/>
            </Box>
            <br/>
            <Box>
              <FooterLink
                href="https://www.caresense.com/privacypolicy"
                target="_blank"
              >
                Privacy Policy
              </FooterLink>
            </Box>
            <Box sx={{ marginBottom: "20px" }}>
              <FooterLink
                href="https://caresense.com/home/qcdr"
                target="_blank"
              >
                QCDR Measure Specification
              </FooterLink>
            </Box>
          </Stack>
        </Container>
      </FooterPaper>
    </AppBar>
  );
}
export default GlobalFooter;
